<template>  
<div> <!-- root element start -->

  <div class="row">
    <div class="col-12">

      <div class="card border-0">
        <div class="card-header h5 bg-transparent border-0">Change Password</div>
        <div class="card-body">

              <hr class="bg-dark">

              <div class="row mb-4"><!--  email row -->

                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Current Password</span>
                </div>

                <div class="col-md-8">
          
                  <div class="row">
                    <div class="col-12">
                      <label class="d-none d-md-block" for="exampleInputEmail1">Current Password</label>
                    </div>

                    <div class="col-12">
                      <div class="row d-flex align-items-center">
                        <div class="col-6">
                          <input :type="curr_pass_type" class="form-control" aria-describedby="emailHelp" placeholder="Current Password" v-model="curr_pass">
                        </div>
                        <div class="col-6">
                          <span class="text-primary" @click="toggleCurrPass" >{{ curr_pass_label }}</span>
                        </div>
                      </div>
                    </div>
                    
                   
                  </div>

                </div>


                <div class="col-md-2  h-100 justify-content-center align-self-center">

                </div>
              </div>
<hr class="bg-dark">
              <div class="row"><!--  email row -->

                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">New Password</span>
                </div>

                <div class="col-md-8">
          
                  <div class="row">
                    <div class="col-12">
                      <label class="d-none d-md-block" for="exampleInputEmail1">New Password</label>
                    </div>

                    <div class="col-12">
                      <div class="row d-flex align-items-center">
                        <div class="col-6">
                          <input :type="new_pass_type" class="form-control" aria-describedby="emailHelp" placeholder="New Password" v-model="new_pass">
                        </div>
                        <div class="col-6">
                          <span class="text-primary" @click="toggleNewPass" >{{ new_pass_label }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mt-2">
                      <p class="small text-muted mb-1 pb-0">A password must be at least ten characters, including 1 lowercase, 1 uppercase, 1 number, and 1 special character.</p>
                    </div>
                   
                  </div>

                </div>


                <div class="col-md-2  h-100 justify-content-center align-self-center">
                  
                </div>
              </div>

              <hr class="bg-dark">

              <div class="row">
                <div class="col-12 text-right">
                  <button @click="cancelData" class="btn btn-warning">Cancel</button>
                  <button @click="submitData" class="btn btn-success">Save Changes</button>

                </div>
              </div>
        </div>
      </div>



    </div> <!--  initial column end -->
  </div> <!--  initial row end -->

</div> <!-- root element end -->
</template>


<script>
import {store} from '../../stores/settings-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {
  store,
  data: function () {
    return { 
      curr_pass: '',
      new_pass: '',

      new_pass_type: 'password',
      new_pass_label: 'Show Password',
      curr_pass_type: 'password',
      curr_pass_label: 'Show Password'
    }
  },
  computed: {
    userData() { return this.$store.state.userData },
    userDataComp() { return this.$store.state.userDataComp },

    passwordButton: function(){
      var _this = this;
      if(_this.curr_pass != '' && _this.new_pass != '' &&  _this.con_pass != '') {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    toggleNewPass(){
      var _this = this;
      if(_this.new_pass_type == 'password') {
        _this.new_pass_type = 'text';
        _this.new_pass_label = 'Hide Password';
      } else {
        _this.new_pass_type = 'password';
        _this.new_pass_label = 'Show Password';
      }
    },
    toggleCurrPass(){
      var _this = this;
      if(_this.curr_pass_type == 'password') {
        _this.curr_pass_type = 'text';
        _this.curr_pass_label = 'Hide Password';
      } else {
        _this.curr_pass_type = 'password';
        _this.curr_pass_label = 'Show Password';
      }
    },
    submitData() {
      var _this = this;
      var valErrors = [];
      _this.$toastr.warning('Validating password information.', 'Please wait!')
      var passRegex1 = /^(?=.*[a-z])/;
      var passRegex2 = /^(?=.*[A-Z])/;
      var passRegex3 = /^(?=.*[0-9])/;
      var passRegex4 = /^(?=.*[!@#\$%\^&\*])/;
      var passRegex5 = /^(?=.{10,})/;
      
      if(_this.curr_pass == '' || _this.curr_pass == null) { valErrors.push("A current password is required!") } 

      if(_this.new_pass == '' || _this.new_pass == null) { 
        valErrors.push("A password is required!") } 
      else {
        if(!_this.new_pass.match(passRegex1)) { valErrors.push("A VALID password must include at least 1 lowercase character!") }  
        if(!_this.new_pass.match(passRegex2)) { valErrors.push("A VALID password must include at least 1 uppercase character!") } 
        if(!_this.new_pass.match(passRegex3)) { valErrors.push("A VALID password must include at least 1 numeric character!") } 
        if(!_this.new_pass.match(passRegex4)) { valErrors.push("A VALID password must include at least 1 special character!") }   
        if(!_this.new_pass.match(passRegex5)) { valErrors.push("A VALID password must include at least 10 characters!") }
      }

      if(valErrors.length > 0) {
        _this.$toastr.remove()
        var errors = valErrors;
        var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
        $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
        errorsHTML += '</ul></div>';
        _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
        return false;
      }

      _this.$toastr.remove()
      _this.$toastr.warning('Updating password information.', 'Please wait!')
      axios.post('/utility/user/user/updateuserpassword',{
        curr_pass: _this.curr_pass,
        new_pass: _this.new_pass,
      })
      .then(function (response) {
        var msg = response.data.msg;
        _this.$toastr.remove()
        _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
        _this.$emit('onSComplete', ['password-edit' ])
      })
      .catch(function (error) {
        var errors = error.response.data.errors;
        var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
        $.each(errors, function(key, value){ errorsHTML += '<li>' + value[0] + '</li>' });
        errorsHTML += '</ul></div>';
        _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
      })


    },
    cancelData() {
      var _this = this;
      _this.$emit('onUComplete', ['password-edit' ])
    }


  },    
  components:{
    
  },
  filters: {

  }
}
</script>
